<div class="active-shipment-card">
    <!-- Card Header -->
    <div class="card-header">
        <div class="header-left">
            <div class="card-icon">
                <mat-icon>local_shipping</mat-icon>
            </div>
            <div class="header-text">
                <h3 class="card-title">Active Shipments</h3>
                <span class="card-subtitle">Recent delivery orders</span>
            </div>
        </div>
        <!-- <div class="header-actions">
            <button class="view-all-btn">
                <span>View All</span>
                <mat-icon>arrow_forward</mat-icon>
            </button>
        </div> -->
    </div>

    <!-- Table Container -->
    <div class="table-container">
        <table class="shipment-table">
            <thead>
                <tr>
                    <th>
                        <div class="th-content">
                            <mat-icon>info</mat-icon>
                            <span>Status</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <mat-icon>calendar_today</mat-icon>
                            <span>Delivery Date</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <mat-icon>location_on</mat-icon>
                            <span>Delivery Location</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <mat-icon>person</mat-icon>
                            <span>Customer Name</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <mat-icon>description</mat-icon>
                            <span>Reference</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <mat-icon>payments</mat-icon>
                            <span>Cost</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <mat-icon>more_horiz</mat-icon>
                            <span>Actions</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of datas; let i = index" class="table-row" [class.even]="i % 2 === 0">
                    <td>
                        <div class="status-badge" [ngClass]="getStatusClass(item.status)">
                            <mat-icon class="status-icon">{{ getStatusIcon(item.status) }}</mat-icon>
                            <span>{{ item.status }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content date">
                            <mat-icon>event</mat-icon>
                            <span>{{ item.deliveryDate }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content location">
                            <mat-icon>place</mat-icon>
                            <span>{{ item.location }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content customer">
                            <div class="customer-avatar">
                                {{ getInitials(item.customerName) }}
                            </div>
                            <span>{{ item.customerName }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content reference">
                            <span class="ref-text">{{ item.ref }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content cost">
                            <span class="cost-value">{{ item.amount }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="action-buttons">
                            <button class="action-btn view" title="View Details">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button class="action-btn edit" title="Edit">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button class="action-btn more" title="More Options">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!datas || datas.length === 0">
        <div class="empty-icon">
            <mat-icon>inventory_2</mat-icon>
        </div>
        <h4>No Active Shipments</h4>
        <p>There are no active shipments to display at the moment.</p>
    </div>

    <!-- Table Footer -->
    <div class="table-footer" *ngIf="datas && datas.length > 0">
        <div class="footer-info">
            <span>Showing <strong>{{ datas.length }}</strong> shipments</span>
        </div>
        <div class="pagination">
            <button class="page-btn" disabled>
                <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="page-info">Page 1 of 1</span>
            <button class="page-btn" disabled>
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
    </div>
</div>
